import { type } from "@testing-library/user-event/dist/type";
import { useEffect, useState } from "react";
import { addCommittee, getAllCommittees, toggleCommitteeStatus, updateCommittee } from "../../services/AdminServices";
import CommitteeList from "../../components/AdminComponents/PagesComponents/Committee/CommitteeList";
import AddCommitteeModal from "../../components/AdminComponents/PagesComponents/Committee/AddCommitteeModal";
import ConfirmActionModal from "../../components/AdminComponents/Modals/ConfirmActionModal";
import MessageModal from "../../components/AdminComponents/Modals/MessageModal";

const AdminCommitteePage = () => {
    const [openModal, setOpenModal] = useState(false);
    const [editData, setEditData] = useState(null);

    const [committees, setCommittees] = useState([]);
    const [loading, setLoading] = useState(false);

    const [confirmModal, setConfirmModal] = useState({
        open: false,
        committee: null
    })

    const [messageModal, setMessageModal] = useState({
        open: false,
        type: "success",
        title: "",
        message: ""
    })

    const showSuccess = (msg) => {
        setMessageModal({
            open: true,
            type: "success",
            title: "Success",
            message: msg
        })
    };

    const showError = (msg) => {
        setMessageModal({
            open: true,
            type: "error",
            title: "Error",
            message: msg
        })
    }

    const handleToggleRequest = (committee) => {
        setConfirmModal({ open: true, committee })
    }

    const handleConfirmToggle = async () => {
        try {
            await toggleCommitteeStatus(confirmModal.committee.id);
            await loadCommittees();
            showSuccess(confirmModal.committee.active ? "Committee deactivated successfully" : "Committee activated successfully.")
        } catch (err) {
            showError(err?.response?.data?.message);
        } finally {
            setConfirmModal({ open: false, committee: null })
        }
    };

    const loadCommittees = async () => {
        try {
            setLoading(true);
            const res = await getAllCommittees();
            if (res.success) {
                setCommittees(res.data);
            }
        } catch (err) {
            console.error(err?.response?.data?.message);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        loadCommittees();
    }, [])

    const handleSave = async (formData) => {
        try {
            console.log("Committee data : ", formData);
            let res;
            if (editData) {
                res = await updateCommittee(editData.id, formData);
            } else {
                res = await addCommittee(formData);
            }

            if (res.success) {
                await loadCommittees();
                setOpenModal(false);
                setEditData(null);
                showSuccess(res.message);
            }
        } catch (err) {
            showError(err?.response?.data?.message || "Something went wrong.");
        }
    }



    return (
        <>
            <div className="p-4 admin-card-box space-y-4">
                <div className="flex justify-between items-center">
                    <h2 className="admin-heading text-blue">Committees</h2>
                    <button
                        className="btnAdd"
                        onClick={() => {
                            setEditData(null);
                            setOpenModal(true)
                        }}
                    >
                        + Add Committee
                    </button>
                </div>
                <CommitteeList
                    data={committees}
                    loading={loading}
                    onEdit={(d) => {
                        setEditData(d);
                        setOpenModal(true);
                    }}
                    onToggle={handleToggleRequest}
                />

                <AddCommitteeModal
                    open={openModal}
                    editData={editData}
                    onClose={() =>  setOpenModal(false)}
                    onSave={handleSave}
                />

                <ConfirmActionModal
                    open={confirmModal.open}
                    title={
                        confirmModal.committee?.active
                            ? "Deactivate Committee"
                            : "Activate Committee"
                    }
                    message={
                        confirmModal.committee?.active
                            ? "Do you really want to deactivate this committee?"
                            : "Do you want to activate this committee again?"
                    }
                    confirmText={
                        confirmModal.committee?.active ? "DEACTIVATE" : "ACTIVATE"
                    }
                    onConfirm={handleConfirmToggle}
                    onClose={() =>
                        setConfirmModal({ open: false, committee: null })
                    }
                />

                <MessageModal
                    open={messageModal.open}
                    type={messageModal.type}
                    title={messageModal.title}
                    message={messageModal.message}
                    onClose={() =>
                        setMessageModal({ ...messageModal, open: false })
                    }
                />
            </div>
        </>
    )
}

export default AdminCommitteePage;